import React from "react";

const CircleStep = ({ totalSteps, filledSteps }) => {
  const size = 40;
  const strokeWidth = 6;
  const radius = (size - strokeWidth) / 2 - 3; // Slight padding
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * radius;
  const gapAngle = 10; // degrees
  const segmentAngle = (360 - totalSteps * gapAngle) / totalSteps;
  const segmentLength = (circumference * segmentAngle) / 360;
  const gapLength = (circumference * gapAngle) / 360;

  return (
    <svg width={size} height={size}>
      {/* Inner solid circle */}
      <circle
        cx={cx}
        cy={cy}
        r={radius - strokeWidth}
        //  fill="#D8D8D8"
        fill={filledSteps === totalSteps ? "#c4d26e" : "#D8D8D8"}
      />

      <g transform={`rotate(-25 ${cx} ${cy})`}>
        {[...Array(totalSteps)].map((_, i) => {
          const rotation = i * (segmentAngle + gapAngle) - 90;
          const isFilled = i < filledSteps;

          return (
            <circle
              key={i}
              cx={cx}
              cy={cy}
              r={radius}
              fill="none"
              stroke={isFilled ? "#c4d26e" : "#D8D8D8"}
              strokeWidth={strokeWidth}
              strokeDasharray={`${segmentLength} ${circumference}`}
              strokeDashoffset={0}
              transform={`rotate(${rotation} ${cx} ${cy})`}
            />
          );
        })}
      </g>
    </svg>
  );
};

const MultiStepProgress = ({ levels, achievedSteps }) => {
  let remaining = achievedSteps;

  return (
    <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
      {levels.map((level, index) => {
        const filled = Math.min(remaining, level.steps);
        remaining -= filled;

        // Check if the line between this level and the next should be filled
        const showLine = filled === level.steps && index < levels.length - 1;

        return (
          <div
            key={index}
            className="position-relative"
            style={{ display: "flex", alignItems: "center" }}
          >
            <CircleStep totalSteps={level.steps} filledSteps={filled} />
            {/* Horizontal line between the steps */}
            {showLine && (
              <div
                style={{
                  // width: '40px',
                  height: "6px",
                  background: `linear-gradient(to right, #c4d26e 100%, #D8D8D8 0%)`,
                  // marginLeft: '-8px', // Overlapping the CircleStep slightly for visual alignment
                  // marginRight: '-8px', // Adjust for spacing between steps
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  right: "-60%",
                  width: "62%",
                }}
              />
            )}
            {/* If the line should not be filled, show a gray line */}
            {!showLine && index < levels.length - 1 && (
              <div
                style={{
                  // width: "40px",
                  height: "6px",
                  backgroundColor: "#D8D8D8",
                  // marginLeft: "-8px", // Overlapping the CircleStep slightly for visual alignment
                  // marginRight: "-8px", // Adjust for spacing between steps
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  right: "-60%",
                  width: "62%",
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

// Example usage
const App = () => {
  return (
    <div style={{ padding: "40px", background: "#f4f4f4" }}>
      <h3 style={{ fontFamily: "sans-serif" }}>Multi-Step Ring Progress</h3>
      <MultiStepProgress
        levels={[{ steps: 5 }, { steps: 5 }, { steps: 5 }]}
        achievedSteps={6} // Adjusted for demonstration (should fill first 5 and 2 from the second)
      />
    </div>
  );
};

export default App;
